<template>
  <div class="section-newsletter">
    <div class="container">
      <div class="section-newsletter-inner">
        <div class="newsletter-content">
          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="newsletter-title">
                Mit dem RuckZuck Newsletter<br>immer gut informiert
              </div>
              <div class="newsletter-form">
                <form class="newsletter-form" action="https://eu.cleverreach.com/f/191124-137330/wcs/" method="post" target="_blank">
                  <div class="form-row">
                    <input id="text3101759" class="borderless" v-model="email" name="email" type="text" placeholder="Ihre E-Mail Adresse" @keyup="handleCaptcha">
                    <input type="submit" class="cr_button">
                  </div>
                  <div id="3101763" rel="recaptcha" class="cr_ipe_item ui-sortable musthave">
                    <div 
                      id="recaptcha_v2_widget" 
                      class="g-recaptcha" 
                      v-show="email !== ''"
                      data-theme="light"
                      data-size="compact"
                      data-sitekey="6Lfhcd0SAAAAAOBEHmAVEHJeRnrH8T7wPvvNzEPD" 
                    />
                  </div>
                </form>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="newsletter-list">
                <ul>
                  <li>Erfahren Sie zuerst von unseren Angeboten & Specials</li>
                  <li>Erhalten Sie Ideen für die Gestaltung mit unseren Böden</li>
                  <li>Tipps für die Verwirklichung Ihrer Projekte</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MSectionNewsletter',
  data () {
    return {
      email: '',
      recaptchaLoaded: false
    }
  },
  methods: {
    async handleCaptcha (e) {
      if (!this.recaptchaLoaded) {
        await this.importScript('https://www.google.com/recaptcha/api.js')
      }
      this.recaptchaLoaded = true
    },
    async importScript (url) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      document.head.appendChild(script);

      await new Promise((resolve) => {
        script.onload = () => {
          resolve()
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
